import React, { useState, useEffect } from "react";
import "../../App.css";
import { useApp } from '../../core/context';
import { sb } from '../../core/db';
import { InlineIcon } from '../../components/Icon';
import { KRAYA, configureKraya } from '../../core/constants';

function KrayaSettings({ showToast }) {
  const { org, setOrg } = useApp();
  const [waOn, setWaOn] = useState(org.whatsapp_automation_enabled !== false);
  const [configured, setConfigured] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    sb.getOrganisationKraya()
      .then((k) => {
        if (k?.whatsapp_automation_enabled !== undefined) setWaOn(!!k.whatsapp_automation_enabled);
        setConfigured(!!k?.configured);
        configureKraya({ automationEnabled: k?.whatsapp_automation_enabled !== false });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    try {
      await sb.updateOrganisationKraya({ whatsapp_automation_enabled: waOn });
      setOrg({ ...org, whatsapp_automation_enabled: waOn });
      configureKraya({ automationEnabled: waOn });
      showToast("WhatsApp settings saved", "success");
    } catch (e) {
      showToast(e.message || "Failed to save settings", "error");
    }
  };

  return (
    <div style={{ maxWidth: 640 }}>
      <div className="card">
        <div className="card-head">
          <div className="card-title">
            <InlineIcon name="whatsapp" size={16} gap={6}>WhatsApp messages</InlineIcon>
          </div>
        </div>
        <div className="card-body">
          {loading ? (
            <div className="f-hint">Loading…</div>
          ) : (
            <>
              <div
                style={{
                  padding: "10px 14px",
                  background: configured ? "#ECFDF5" : "#F3F4F6",
                  border: `1px solid ${configured ? "#A7F3D0" : "var(--border)"}`,
                  borderRadius: 8,
                  fontSize: 13,
                  color: configured ? "#065F46" : "var(--muted)",
                  marginBottom: 16,
                }}
              >
                {configured
                  ? "WhatsApp is connected on the server."
                  : "WhatsApp is being connected on the server. You can still choose whether automated messages are on or off."}
              </div>
              <label style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
                <input type="checkbox" checked={waOn} onChange={(e) => setWaOn(e.target.checked)} />
                Send automated WhatsApp messages
              </label>
              <div className="f-hint" style={{ marginTop: 8 }}>
                Covers invoice, task, payment, and welcome notifications, plus scheduled reminders. In-app notifications are unaffected.
              </div>
              <div style={{ marginTop: 20 }}>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 10 }}>Template names (for your Kraya account)</div>
                <div style={{ background: "#FAFAF8", borderRadius: 10, overflow: "hidden" }}>
                  {Object.entries(KRAYA.TEMPLATES).map(([k, v], i) => (
                    <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "9px 14px", borderBottom: i < Object.keys(KRAYA.TEMPLATES).length - 1 ? "1px solid #F3F4F6" : "none", fontSize: 12 }}>
                      <span style={{ color: "var(--muted)" }}>{k.replace(/_/g, " ")}</span>
                      <span style={{ fontWeight: 600 }}>{v}</span>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
        <div style={{ padding: "0 20px 20px" }}>
          <button className="btn btn-primary" onClick={save} disabled={loading}>Save</button>
        </div>
      </div>
    </div>
  );
}

export { KrayaSettings };
